import {
  GAZA,
  B2R_SAB3,
  HAIFA,
  YAFA,
  RAMLA,
  GANIN,
  NABLUS,
  TULKARM,
  SAFED,
  AKKA,
  NAZARETH,
  TIBERIAS,
  BEISAN,
  QUDUS,
  RAMALLAH,
  HEBRON,
} from "../constants/states";

const DEPARTMENTS_STATES = {
  GAZA_DEPARTMENT: [GAZA, B2R_SAB3],
  QUDUS_DEPARTMENT: [QUDUS, RAMALLAH, HEBRON],
  LOD_DEPARTMENT: [YAFA, RAMLA],
  HAIFA_DEPARTMENT: [HAIFA],
  GALILEE_DEPARTMENT: [SAFED, AKKA, NAZARETH, BEISAN, TIBERIAS],
  SAMARIA_DEPARTMENT: [GANIN, NABLUS, TULKARM],
};


export default DEPARTMENTS_STATES